import { render, staticRenderFns } from "./phoneteamsale.vue?vue&type=template&id=f532126a&scoped=true"
import script from "./phoneteamsale.vue?vue&type=script&lang=js"
export * from "./phoneteamsale.vue?vue&type=script&lang=js"
import style0 from "./phoneteamsale.vue?vue&type=style&index=0&id=f532126a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f532126a",
  null
  
)

export default component.exports